
        <ig-water-fall-container #waterfall [itemWidth]="300" [isAllItemsLoaded]="isAllDataLoaded"
                                 (onLoadMore)="loadMore($event)">
            <div *ngFor="let item of items" [ngStyle]="item.styles">
                {{item.value}}
            </div>
        </ig-water-fall-container>
    


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/fall.component.ts.FallComponent.html